// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--5-1!./happy-scroll.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("79d678ef", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-happy-scroll/docs/happy-scroll.css
// module id = 596
// module chunks = 8